import styles from "../styles/Info.module.css";

function Icon({ name }) {
  const common = {
    className: styles.icon,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
  };

  switch (name) {
    case "mail":
      return (
        <svg {...common}>
          <path
            d="M4 7.5A2.5 2.5 0 0 1 6.5 5h11A2.5 2.5 0 0 1 20 7.5v9A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-9Z"
            stroke="currentColor"
            strokeWidth="1.7"
          />
          <path
            d="M6.5 7.5 12 12l5.5-4.5"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "linkedin":
      return (
        <svg {...common}>
          <path
            d="M6.5 9.5V18"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
          <path
            d="M6.5 6.8h.01"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <path
            d="M10.2 18v-4.6c0-2.1 1.1-3.3 2.8-3.3 1.6 0 2.5 1.1 2.5 3.1V18"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.2 11.2V18"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
        </svg>
      );
    case "pin":
      return (
        <svg {...common}>
          <path
            d="M12 21s6-4.5 6-10a6 6 0 1 0-12 0c0 5.5 6 10 6 10Z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
          <path
            d="M12 11.2a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"
            stroke="currentColor"
            strokeWidth="1.7"
          />
        </svg>
      );
    case "doc":
      return (
        <svg {...common}>
          <path
            d="M7 3.5h7l3 3V20.5A2 2 0 0 1 15 22H7a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2Z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
          <path
            d="M14 3.5V7h3"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
          <path
            d="M8 11h8M8 14.5h8M8 18h6"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
        </svg>
      );
    default:
      return null;
  }
}

function Row({ icon, label, value, href }) {
  const content = (
    <>
      <span className={styles.rowLeft}>
        <Icon name={icon} />
        <span className={styles.rowLabel}>{label}</span>
      </span>
      <span className={styles.rowValue}>{value}</span>
    </>
  );

  return href ? (
    <a className={styles.row} href={href} target="_blank" rel="noreferrer">
      {content}
    </a>
  ) : (
    <div className={styles.row}>{content}</div>
  );
}

export default function Info() {
  return (
    <>
      <section className={styles.infoSection}>
        <div className={styles.inner}>
          <div className={styles.grid}>
            <article className="card">
              <header className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>Contact</h3>
              </header>

              <div className={styles.rows}>
                <Row
                  icon="mail"
                  label="Email"
                  value="krzysztof.m.chabowski@gmail.com"
                  href="mailto:krzysztof.m.chabowski@gmail.com"
                />
                <Row
                  icon="linkedin"
                  label="LinkedIn"
                  value="/in/krzysztof-chabowski"
                  href="https://www.linkedin.com/in/krzysztof-chabowski"
                />
              </div>
            </article>

            <article className="card">
              <header className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>Legal info</h3>
              </header>

              <div className={styles.rows}>
                <Row
                  icon="doc"
                  label="Business"
                  value="Krzysztof M. Chabowski"
                />
                <Row
                  icon="pin"
                  label="Address"
                  value={
                    <>
                      ul. Tadeusza Szafrana 5C/57
                      <br />
                      30-363 Kraków, Poland
                    </>
                  }
                />
                <Row icon="doc" label="NIP" value="8571881386" />
                <Row icon="doc" label="REGON" value="387105503" />
              </div>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}
